import { TDateState } from '../../../DateOfBirthFieldWithProvider';
import { IDateData, ISetValueCase } from '../inputDateReducer';
import getAge from './getAge';
import isTooOld from './isTooOld';
import isTooYoung from './isTooYoung';

export function ageVerification(
	state: IDateData,
	{ target, minAge, maxAge, payload }: ISetValueCase,
) {
	const age = getAge({
		year: target === 'year' ? payload.slice(0, 4) : state.year.value,
		month: target === 'month' ? payload.slice(0, 2) : state.month.value,
		day: target === 'day' ? payload.slice(0, 2) : state.day.value,
	});

	if (isTooOld(age, maxAge) || isTooYoung(age, minAge)) {
		return false;
	}
	return true;
}

export function isValidAge(
	currentDateState: TDateState,
	maxAge: number,
	minAge: number
) {

	const age = getAge({ year: currentDateState.year.value, month: currentDateState.month.value, day: currentDateState.day.value })

	if (isTooOld(age, maxAge) || isTooYoung(age, minAge)) {
		return false;
	}
	return true;
}